// action
import {
    DELETE_PATIENT_LIST,
    DELETE_PATIENT_LIST_FAIL,
    DELETE_PATIENT_LIST_SUCCESS,
    DELETE_PATIENT_LIST_RESET
} from '../action/deletePatientListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}


export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_PATIENT_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_PATIENT_LIST_FAIL:
            // console.log("hii",message)
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_PATIENT_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_PATIENT_LIST_RESET:
            return initialState
        default:
            return state
    }
}